<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label>Job</label>
                    <input type="text" class="form-control" [value]="target.jobDisplay" disabled />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <div class="form-check">
                        <input
                            id="excluded"
                            type="checkbox"
                            class="form-check-input"
                            [(ngModel)]="target.excluded"
                            name="excluded"
                            (ngModelChange)="onExcludedChanged()"
                        />
                        <label class="form-check-label" for="excluded">Exclude from Manpower within bid (excl. outliers)</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="reason">Reason</label>
                    <textarea
                        id="reason"
                        class="form-control"
                        rows="3"
                        maxlength="500"
                        [(ngModel)]="target.reason"
                        name="reason"
                        [required]="target.excluded"
                    ></textarea>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="effectiveOn">Effective date</label>
                    <wj-input-date
                        id="effectiveOn"
                        [(ngModel)]="target.effectiveOn"
                        name="effectiveOn"
                        [isRequired]="target.excluded"
                    ></wj-input-date>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
